import { render } from "./SsoAuth.vue?vue&type=template&id=5359f286"
import script from "./SsoAuth.vue?vue&type=script&lang=js"
export * from "./SsoAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__